import { PROPOSAL_RIDERS } from "../constant/gms-constant";

export const getAmountValidationMessage = (riderId: number, riderLabel: string, inputLabel: string) => {
    // if (Object.values(PROPOSAL_RIDERS.GDR.productFor).some((id) => id === riderId)) {
    //     return `${riderLabel} (${inputLabel}) must select at least one.`;
    // }
    
    if (Object.values(PROPOSAL_RIDERS.GHIR.productFor).some((id) => id === riderId)) {
        return `${riderLabel} (${inputLabel}) amount must be between 100 and 300.`;
    }

    if (Object.values(PROPOSAL_RIDERS.GAMERR.productFor).some((id) => id === riderId)) {
        return `${riderLabel} (${inputLabel}) amount must be at least 500.`;
    }

    if (Object.values(PROPOSAL_RIDERS.GMBDR.productFor).some((id) => id === riderId)) {
        return `${riderLabel} (${inputLabel}) amount must be either 10,000, 20,000, or 30,000.`;
    }

    return `${riderLabel} (${inputLabel}) must have an amount.`;
};